import { Layout } from 'antd';
import type { PropsWithChildren } from 'react';

import { ReduxProvider } from '@/components/redux-provider';
import { ScopeHeadersProvider } from '@/components/scope-headers-provider';
import { useSidebarContext } from '@/contexts/sidebar-context';

import { OrgNavbar } from './org-navbar';
import { OrgSidebar } from './org-sidebar';

const { Content } = Layout;

function LayoutContent({ children }: PropsWithChildren) {
  const { desktop } = useSidebarContext();

  return (
    <Layout>
      <OrgSidebar />

      <Layout
        style={{
          marginLeft: desktop.isCollapsed ? 64 : 256,
          transition: 'margin-left 0.2s',
        }}
      >
        <Content
          style={{
            paddingTop: 64,
            minHeight: 'calc(100vh - 64px)',
          }}
        >
          <div className="p-6">{children}</div>
        </Content>
      </Layout>
    </Layout>
  );
}

export function OrgLayoutWrapper({ children }: PropsWithChildren) {
  return (
    <ReduxProvider>
      <ScopeHeadersProvider>
        <Layout className="min-h-screen">
          <OrgNavbar />
          <LayoutContent>{children}</LayoutContent>
        </Layout>
      </ScopeHeadersProvider>
    </ReduxProvider>
  );
}
